import {
    SET_SHOW_DOORS,
    DRAG_DIMENSION_VALUE,
    SELECT_ALL_TOGGLE,
    SORT_ASCENDING,
    SORT_DESCENDING,
    MOVE_METRIC,
    TOGGLE_ASSORTMENT_TOTALS,
    TOGGLE_METRIC,
    TOGGLE_SWITCH,
    MOVE_ATTRIBUTE,
    TOGGLE_DIMENSION_VALUE,
    TOGGLE_ATTRIBUTE_LABEL,
    SET_DRAFT,
    SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE,
    TOGGLE_PLAN_TOTALS,
} from "actions/tool-panel/draft/constants";
import { handleActions } from "redux-actions";
import {
    dragValueHandler,
    moveAttributeHandler,
    moveMetricHandler,
    selectAllValuesHandler,
    setShowDoorsHandler,
    sortAscendingHandler,
    sortDescendingHandler,
    syncAllocationDimensionUpdates,
    toggleAssortmentTotalsHandler,
    toggleAttributeLabelHandler,
    toggleMetricHandler,
    togglePlanTotalsHandler,
    toggleValueHandler,
    togglerMetricSwitchHandler,
} from "./handlers";
import { DimensionsPanelReduxState } from "../dimensions-panel";
import { SetDraft } from "actions/tool-panel/draft/types";
import { PayloadParam } from "actions/utilities/payload-param-type";
import { DoorGroupMetric, Metrics, MetricsKind, Metric } from "helpers/metrics/types";
import { capitalize } from "lodash";
import { getInitialState } from "../applied/initial-state";
import { forceShowDoorsOnHOF } from "./forceShowDoorsOnHOF";

export const draft = handleActions<DimensionsPanelReduxState, any>(
    {
        [SET_DRAFT]: (_state: DimensionsPanelReduxState, { payload }: PayloadParam<SetDraft>) => {
            return { ...payload };
        },
        [SET_SHOW_DOORS]: setShowDoorsHandler,
        [SELECT_ALL_TOGGLE]: forceShowDoorsOnHOF(selectAllValuesHandler),
        [TOGGLE_DIMENSION_VALUE]: forceShowDoorsOnHOF(toggleValueHandler),
        [SORT_ASCENDING]: forceShowDoorsOnHOF(sortAscendingHandler),
        [SORT_DESCENDING]: forceShowDoorsOnHOF(sortDescendingHandler),
        [DRAG_DIMENSION_VALUE]: forceShowDoorsOnHOF(dragValueHandler),
        [MOVE_ATTRIBUTE]: forceShowDoorsOnHOF(moveAttributeHandler),
        [TOGGLE_ATTRIBUTE_LABEL]: forceShowDoorsOnHOF(toggleAttributeLabelHandler),
        [TOGGLE_METRIC]: forceShowDoorsOnHOF(toggleMetricHandler),
        [TOGGLE_SWITCH]: forceShowDoorsOnHOF(togglerMetricSwitchHandler),
        [MOVE_METRIC]: forceShowDoorsOnHOF(moveMetricHandler),
        [TOGGLE_ASSORTMENT_TOTALS]: forceShowDoorsOnHOF(toggleAssortmentTotalsHandler),
        [TOGGLE_PLAN_TOTALS]: forceShowDoorsOnHOF(togglePlanTotalsHandler),
        [SYNC_RECEIVED_UPDATES_WITH_DIMENSION_PANEL_STATE]: syncAllocationDimensionUpdates,
    },

    getInitialState()
);

export const getDefaultDoorGroupMetric = (kind) => ({
    show_value: false,
    show_totals: false,
    show_subtotals: false,
    display_name: capitalize(kind.replace(/_/g, " ")),
    read_only: false,
    kind,
});

/**
 * Translate metric from the schema into UI state
 */
export const parseMetricSchema = (metricSchema: DoorGroupMetric[]): Metrics => {
    return metricSchema.reduce((acc, metricScheme) => {
        // Only translate known metric
        if (MetricsKind[metricScheme.kind] !== undefined) {
            acc.push({
                showValue: metricScheme.show_value,
                showSubtotals: metricScheme.show_subtotals,
                showTotals: metricScheme.show_totals,
                numberFormat: metricScheme.number_format,
                kind: metricScheme.kind,
                displayName: metricScheme.display_name,
                isTargetMetric: metricScheme.target_view?.is_target_metric ?? false,
            });
        }
        return acc;
    }, [] as Metrics);
};

export const getDefaultMetrics = () =>
    Object.keys(MetricsKind).map<Metric>((kind: MetricsKind) => ({
        showValue: false,
        showSubtotals: false,
        showTotals: false,
        kind,
        displayName: kind.toUpperCase(),
        isTargetMetric: false,
    }));
